// Ejemplo de validación para mostrar los errores del backend
import React from 'react';

export default function ValidationErrors({ errors }) {
  if (!errors || typeof errors !== 'object') return null;
  return (
    <div className="bg-red-100 text-red-700 p-2 rounded mb-2">
      <ul className="list-disc pl-5">
        {Object.entries(errors).map(([field, msgs]) => (
          <li key={field}><strong>{field}:</strong> {Array.isArray(msgs) ? msgs.join(', ') : msgs}</li>
        ))}
      </ul>
    </div>
  );
}
